import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation
} from "react-router-dom";

import Preloader from "./components/Pre";
import Navbar from "./components/layout/Navbar/Navbar";
import Footer from "./components/layout/Footer/Footer";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import ProjectDetailPage from "./pages/projects/ProjectDetailPage";
import ScrollToTop from "./components/ScrollToTop";

import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function HashNavigationManager() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;

    const sectionId = location.hash.slice(1);
    let attempts = 0;

    const scrollToSection = () => {
      const section = document.getElementById(sectionId);
      if (section) {
        const navbarOffset = 76;
        const top = section.getBoundingClientRect().top + window.scrollY - navbarOffset;
        window.scrollTo({ top, behavior: "smooth" });
        return;
      }

      attempts += 1;
      if (attempts < 12) window.setTimeout(scrollToSection, 100);
    };

    const timer = window.setTimeout(scrollToSection, 100);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  const [load, setLoad] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setLoad(false), 1200);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <HashNavigationManager />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
